import React from 'react';
import { Helmet } from 'react-helmet';  // Importera Helmet

export default function ThankYou() {
  return (
    <>
    <Helmet>
        <title>Flyttstädning | fast pris | Kundnöjdhetsgaranti - Provalt Service AB</title>
        <meta name="description" content="Professionell och noggrann flyttstädning för ditt hem eller kontor. Vi ser till att ditt gamla boende är skinande rent inför nästa hyresgäst eller köpare." />
      <link rel="canonical" href="https://provalt.se/tack" /></Helmet>
      
    <div style={styles.wrapper}>
      <h2 style={styles.heading}>Tack för din bokning!</h2>
      <p>Vi har skickat en bekräftelse till din e-post.</p>
      <p>Du kommer även att bli kontaktad inför städningen.</p>
      <p style={styles.footer}>Har du frågor? Kontakta oss på <a href="mailto:info@provalt.se">info@provalt.se</a>.</p>
    </div>
    </>
  );
}

const styles = {
  wrapper: {
    maxWidth: '500px',
    margin: '60px auto',
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    backgroundColor: '#f9f9f9',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  heading: {
    fontSize: '24px',
    color: '#2E86C1',
    marginBottom: '20px',
  },
  footer: {
    marginTop: '30px',
    fontSize: '14px',
    color: '#333',
  },
};
